import * as React from "react";

function Settings(props) {
  return (
    <svg width={16} height={16} fill="none" {...props}>
      <path
        clipRule="evenodd"
        d="M13.871 5.082l-.415-.72a1.275 1.275 0 00-1.739-.47 1.27 1.27 0 01-1.74-.451 1.22 1.22 0 01-.17-.61 1.275 1.275 0 00-1.275-1.312h-.836a1.27 1.27 0 00-1.27 1.275 1.275 1.275 0 01-1.275 1.257 1.22 1.22 0 01-.61-.17 1.275 1.275 0 00-1.74.47l-.445.731a1.275 1.275 0 00.464 1.74 1.275 1.275 0 010 2.209 1.27 1.27 0 00-.464 1.732l.421.727a1.275 1.275 0 001.74.494 1.263 1.263 0 011.732.464c.11.185.169.395.171.61 0 .704.571 1.275 1.276 1.275h.836c.702 0 1.272-.567 1.275-1.269a1.27 1.27 0 011.275-1.275c.215.005.424.064.61.17.61.351 1.387.144 1.74-.463l.44-.732a1.27 1.27 0 00-.465-1.74 1.27 1.27 0 010-2.202c.604-.353.81-1.126.464-1.734v-.006z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.117 9.683a1.757 1.757 0 100-3.514 1.757 1.757 0 000 3.514z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

const SettingsIcon = React.memo(Settings);
export default SettingsIcon;
